import { Cover } from '../store/template/postPage/postPage.reducer';

export const getCoverType = (cover: Cover) => {
    if (cover.media) {
        return cover.media.type;
    }
    return 'image';
};
function getCookieByName(name: string) {
    // @ts-ignore
    return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
}

export function getCountryCode() {
    return getCookieByName('countryCode');
}
